import * as url from "../../helpers/url_helper";
import { apiCall } from "./apiService";

/**
 * Updates common settings for a store
 * @param {string} storeDomain - Store domain
 * @param {boolean} isCampaignLinks - Whether campaign links are enabled
 * @param {boolean} isCouponBlocker - Whether coupon blocker is enabled
 * @param {boolean} isSmartDiscount - Whether smart discount is enabled
 * @param {Function} notifyError - Error notification function
 * @returns {Promise<Object|null>} Response data or null if error
 */
export const updateCommonSettings = async (storeDomain, isCampaignLinks, isCouponBlocker, isSmartDiscount, notifyError) => {
    return await apiCall(
        url.PUT_UPDATE_STORE,
        'PUT',
        {
            store_domain: storeDomain,
            is_campaign_links: isCampaignLinks,
            is_coupon_blocker: isCouponBlocker,
            is_smart_discount: isSmartDiscount,
        },
        notifyError,
        "Failed to update common settings"
    );
};

